/* eslint-disable no-unused-vars */
import { useMemo } from 'react';
import { Palette } from 'config';
import styled, { css } from 'styled-components';

export const TargetedLocation = ({ value, data }) => {
  const isDeletedCampaign = useMemo(() => {
    return data.campaignStatus === 9;
  }, [data.campaignStatus]);

  const valueToShow = useMemo(() => {
    if (!value) return 'All countries';
    if (value.split(',').length > 3) {
      const res = value.split(',').slice(0, 3).join(',');
      const additionalNumber = value.split(',').length;
      return `${res} + ${additionalNumber - 3}`;
    }
    return value;
  });

  return !isDeletedCampaign && <Container>{valueToShow}</Container>;
};

const Container = styled.p`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
  color: ${Palette.PrimaryGray._700};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;
